import { __extends } from "tslib";
import { OpCodes } from './OpCodes';
import { GLESAssetBase } from './GLESAssetBase';
var TextureBaseGLES = /** @class */ (function (_super) {
    __extends(TextureBaseGLES, _super);
    function TextureBaseGLES(context, gl, id) {
        var _this = _super.call(this, context, id) || this;
        _this.textureType = '';
        return _this;
        // this._gl = gl;
    }
    TextureBaseGLES.prototype.dispose = function () {
        //console.log("dispose texturedata "+this.id);
        ///this._context.addStream(String.fromCharCode(OpCodes.disposeTexture) + this.id.toString() + "#END");
        this._context._createBytes.writeInt(OpCodes.disposeTexture);
        this._context._createBytes.writeInt(this.id);
        //this._context.execute();
        //GLESConnector.gles.disposeTexture(this.id);
        // this._gl.deleteTexture(this._glTexture);
    };
    Object.defineProperty(TextureBaseGLES.prototype, "glTexture", {
        get: function () {
            return this._glTexture;
        },
        enumerable: false,
        configurable: true
    });
    TextureBaseGLES.prototype.generateMipmaps = function () {
        //GLESConnector.gles.generateMipmaps(this.id);
        // this._gl.bindTexture( this._gl.TEXTURE_2D, this._glTexture );
        // this._gl.generateMipmap(this._gl.TEXTURE_2D);
        // //this._gl.bindTexture( this._gl.TEXTURE_2D, null );
    };
    return TextureBaseGLES;
}(GLESAssetBase));
export { TextureBaseGLES };
